"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaybackTab = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const text_field_1 = require("client/components/material/text-field");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const store_2 = require("../../store");
require("./eob-payback.less");
const dummyHeader = {
    pharmacy: "",
    payer: "",
    eobDate: new Date(),
    checkNumber: "",
    checkTotal: null,
    eobTotal: null,
    interestPayment: null,
    copay: false,
    posFee: null,
    dirFee: null,
    EOB: 0
};
const dummyDetail = {
    amountPaid: null,
    awp: null,
    dateOfService: new Date(),
    rxNumber: null || "",
    autoReverse: false,
    claimId: null,
    drugName: "",
    posFees: null,
    dirFees: null,
    insReimb: null,
    claimStatus: ""
};
let PaybackTab = class PaybackTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.displayEobTotal = "0.00";
        this.selectedHeaderInitialEobTotal = 0;
        this.claimBinNum = "";
        this.claimPcn = "";
        this.claimGroupId = "";
        this.buttonSaved = false;
        this.loading = false;
        this.eobSiteId = 0; // so IMB users can select pharmacy to make eob.
        this.currentUserId = 0; // so IMB users can be recorded in ledger when entering eob details.
        this.siteImbFee = 0; // to get the IMB fee for the selected pharmacy to update ledger.
        this.eobHeader = dummyHeader;
        this.eobDetail = dummyDetail;
        this.selectedPaybackEobDetail = [];
        this.initializeEob = () => {
            const { selectedRowsPayback } = store_2.eobStore;
            if (selectedRowsPayback) {
                this.eobHeader.pharmacy = selectedRowsPayback[0].PharmacyName;
                this.eobHeader.payer = selectedRowsPayback[0].PayerName;
                this.eobSiteId = selectedRowsPayback[0].siteId;
                // calculate eob total
                this.eobHeader.eobTotal = selectedRowsPayback.reduce((cur, acc) => Number(cur) +
                    Number(acc.ReimbAmount) -
                    Number(acc.posFees) -
                    Number(acc.dirFees), 0);
                this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
                this.selectedHeaderInitialEobTotal = this.eobHeader.eobTotal;
                selectedRowsPayback.map((row) => {
                    const { RXNumber, DOS, PatientBin, PatientPCN, PatientGroupId, ReimbAmount, claimId, posFees, dirFees, drugName, awp, payerId } = row;
                    this.eobDetail.amountPaid = -ReimbAmount;
                    this.eobDetail.awp = awp;
                    this.eobDetail.dateOfService = DOS;
                    this.eobDetail.rxNumber = RXNumber;
                    this.eobDetail.claimId = claimId;
                    this.eobDetail.drugName = drugName;
                    this.eobDetail.posFees = -posFees;
                    this.eobDetail.dirFees = -dirFees;
                    this.claimBinNum = PatientBin;
                    this.claimPcn = PatientPCN;
                    this.claimGroupId = PatientGroupId;
                    this.selectedPaybackEobDetail.push(Object.assign(Object.assign({}, this.eobDetail), { bin: this.claimBinNum, pcn: this.claimPcn, groupId: this.claimGroupId }));
                });
            }
        };
        this.resetHeader = () => {
            this.eobHeader = dummyHeader;
            this.displayEobTotal = "";
        };
        this.resetDetail = () => {
            this.displayEobTotal = "0.00";
            this.eobDetail = dummyDetail;
            this.claimBinNum = "";
            this.claimGroupId = "";
            this.claimPcn = "";
            this.selectedPaybackEobDetail = [];
        };
        this.renderPaybackPage = () => (React.createElement("div", { className: "eob__payback" },
            React.createElement("div", { className: "eob-payback__headline" },
                React.createElement("div", null,
                    React.createElement(core_1.Typography, { variant: "display1" }, "Negative Balance Payback")),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement(core_1.Typography, { variant: "subheading" }, "No RX Numbers have been selected to pay pharmacy's negative balance to an insurance."),
                    React.createElement("br", null),
                    React.createElement(core_1.Typography, { variant: "subheading" }, "Please go to Negative Balances Report in Reporting to select the specific RX Numbers for negative balance payback to an insurance."))),
            React.createElement("br", null),
            React.createElement("br", null)));
        this.renderEobHeader = () => (React.createElement("div", { className: "eob__header" },
            React.createElement("div", { className: "edit-eob-header" },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.MaterialTextField, { disabled: true, label: "Pharmacy", value: this.eobHeader.pharmacy }),
                    React.createElement(text_field_1.MaterialTextField, { className: "payer", label: "Payer Name", disabled: true, value: this.eobHeader.payer }),
                    React.createElement(date_picker_1.MaterialDatePicker, { className: "eob-date", label: "Check Date *", missing: this.missing.eobDate, onChange: this.handleChangeEobDate, value: this.eobHeader.eobDate || "" })),
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.MaterialTextField, { className: "check-amount", required: true, label: "Check Amount", missing: this.missing.checkAmount, onChange: this.handleChangeString("checkTotal"), value: this.eobHeader.checkTotal || "" }),
                    React.createElement(text_field_1.MaterialTextField, { className: "check-number", required: true, label: "Pharmacy Issued Check Number", missing: this.missing.checkNum, onChange: this.handleChangeString("checkNumber"), value: this.eobHeader.checkNumber || "" }),
                    React.createElement(text_field_1.MaterialTextField, { className: "eob-total", label: "EOB Total", disabled: true, value: this.displayEobTotal || "0.00" })),
                React.createElement("br", null))));
        this.renderEobDetail = () => (React.createElement("div", { className: "eob__detail" },
            React.createElement("div", { className: "edit-eob-detail" },
                React.createElement(ui_1.UiForm, { buttons: [
                        React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                        "Process EOB"
                    ], className: "eob-detail-form", onSubmit: this.handleSubmit, loading: this.loading, status: ui_1.FormStatus.Dirty, shouldDisableSave: this.buttonSaved, saved: "Saved", error: this.props.error },
                    console.log("detail array here ---------------<<<<<<<<<<<---->>>>>>>>>>>>>>>>>", this.selectedPaybackEobDetail),
                    this.renderEobHeader(),
                    React.createElement("br", null),
                    store_2.eobStore.showPayback && (React.createElement("div", { className: "edit-eob-detail" }, this.selectedPaybackEobDetail.map((eobDetail, index) => this.renderDetailHistory(eobDetail, index))))))));
        this.renderDetailHistory = (eobDetail, index) => (React.createElement("div", { className: "row", key: index },
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "rx-num", label: "RX #", disabled: true, value: eobDetail.rxNumber }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "amount-paid", label: "Amount Paid", disabled: true, value: eobDetail.amountPaid || "0.00" }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pos-fees", label: "POS Fees", onChange: this.handleChangeAddedFees("posFees", eobDetail, index), value: eobDetail.posFees || "0.00" }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "dir-fees", label: "DIR Fees", onChange: this.handleChangeAddedFees("dirFees", eobDetail, index), value: eobDetail.dirFees || "0.00" }),
            React.createElement(date_picker_1.MaterialDatePicker, { className: "claim-date", label: "Date of Service", disabled: true, value: eobDetail.dateOfService }),
            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "desc", label: "Drug Name", disabled: true, value: eobDetail.drugName || "" })));
        this.renderEntry = () => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "eob__header" },
                React.createElement("div", { className: "edit-eob-header" },
                    React.createElement("div", { className: "eob-header-form__headline" },
                        React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "New EOB Entry - Negative Balance Payback")))),
            this.renderEobDetail()));
        this.handleCancel = () => {
            this.eobHeader = dummyHeader;
            this.eobDetail = dummyDetail;
            this.displayEobTotal = "0.00";
            this.claimBinNum = "";
            this.claimGroupId = "";
            this.claimPcn = "";
            this.selectedHeaderInitialEobTotal = 0;
            this.selectedPaybackEobDetail = [];
            store_2.eobStore.showPayback = false;
            this.buttonSaved = false;
        };
        this.handleSubmit = async () => {
            if (this.selectedPaybackEobDetail.length === 0) {
                alert("Please select specific RX Numbers from Negative Balances Report.");
                return;
            }
            this.loading = true;
            // console.log("this.loading", this.loading);
            this.missing = {
                sites: false,
                payer: false,
                eobDate: false,
                checkAmount: false,
                checkNum: false
            };
            const headerId = await store_2.eobStore.insertHeader(this.eobHeader, this.currentUserId);
            // console.log("header id after insert header", this.headerId);
            // console.log("this.eobHeader", this.eobHeader);
            // insert into eob detail
            await store_2.eobStore.insertDetail(this.selectedPaybackEobDetail, Number(headerId), this.currentUserId, this.eobHeader.payer);
            // insert fees in ledger
            const result = await store_2.eobStore.insertLedger(this.selectedPaybackEobDetail, this.eobHeader, Number(headerId), this.eobSiteId, this.siteImbFee, this.currentUserId);
            if (result) {
                this.buttonSaved = true;
            }
            setTimeout(() => (this.loading = false), 1000);
            this.resetHeader();
            this.resetDetail();
            store_2.eobStore.showPayback = false;
            this.buttonSaved = false;
            router_1.RouteManager.transitionTo(`/eob/eobfees`);
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            console.log("value ====>>", value);
            this.eobHeader[fieldName] = value;
        };
        this.handleChangeAddedFees = (fieldName, eobDetail, index) => (event, value) => {
            if (value === "-") {
                this.selectedPaybackEobDetail[index][fieldName] = value;
                eobDetail[fieldName] = value;
                return;
            }
            this.selectedPaybackEobDetail[index][fieldName] = +value;
            eobDetail[fieldName] = value;
            // calculate eob total
            this.eobHeader.eobTotal = this.selectedPaybackEobDetail.reduce((cur, acc) => {
                console.log("cur", cur, "acc.amountPaid", acc.amountPaid);
                return (Number(cur) +
                    Number(acc.amountPaid) -
                    Number(acc.posFees) -
                    Number(acc.dirFees));
            }, this.selectedHeaderInitialEobTotal);
            // console.log("asdfsdafd-----------", this.eobHeader.eobTotal);
            this.displayEobTotal = this.eobHeader.eobTotal.toFixed(2);
            this.buttonSaved = false;
        };
        this.handleChangeEobDate = (value) => {
            // string to Date
            this.eobHeader.eobDate = value;
        };
    }
    async componentWillMount() {
        this.missing = {
            sites: false,
            payer: false,
            eobDate: false,
            checkAmount: false,
            checkNum: false
        };
    }
    async componentDidMount() {
        this.currentUserId =
            store_1.usersStore.user && store_1.usersStore.user.value && store_1.usersStore.user.value.id
                ? store_1.usersStore.user.value.id
                : 0;
        this.initializeEob();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentWillUnmount() {
        store_2.eobStore.showPayback = false;
    }
    render() {
        const { showPayback } = store_2.eobStore;
        return showPayback ? this.renderEntry() : this.renderPaybackPage();
    }
};
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "displayEobTotal", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "selectedHeaderInitialEobTotal", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "claimBinNum", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "claimPcn", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "claimGroupId", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "buttonSaved", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "eobSiteId", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "currentUserId", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "siteImbFee", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "eobHeader", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "eobDetail", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], PaybackTab.prototype, "selectedPaybackEobDetail", void 0);
PaybackTab = __decorate([
    mobx_react_1.observer
], PaybackTab);
exports.PaybackTab = PaybackTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/tabs/eob-payback/eob-payback.tsx
// module id = 3438
// module chunks = 0